import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import Amplify, { Auth } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";

import { createUserdata, updateUserdata } from "../graphql/mutations";
import { listUserdatas } from "../graphql/queries";

function update_auth_data() {
  Auth.currentAuthenticatedUser()
    .then((user) => {
      store.commit("SET_cognito_user", user);
      store.commit("SET_logged_in", true);
      updateUserInfo();
    })
    .catch((err) => {
      // not authenticated
      //console.error('SET_cognito_user', err)
      store.commit("SET_cognito_user", null);
      store.commit("SET_user_info", null);
      store.commit("SET_logged_in", false);
    });
}

function updateUserInfo() {
  Auth.currentUserInfo()
    .then((user_info) => {
      store.commit("SET_user_info", user_info);
    })
    .catch((err) => {
      //console.error('SET_user_info', err)
      store.commit("SET_user_info", null);
    });
}

update_auth_data();

AmplifyEventBus.$on("authState", (info) => {
  update_auth_data();
});

AmplifyEventBus.$on("updateAuthData", (info) => {
  update_auth_data();
});

// TODO: Move these modules into their own files as they grow
// ALSO use mapGetters and namespaces in vue components
const originalStore = {
  state: {
    max_seq_nr: null,
    measureSet_max_seq_nr: null,
    searches: {},
    activeCompany: null,
    cognito_user: null,
    user_info: null,
    logged_in: false,
    sidebarVisible: true,
    selectedCompany: null,
  },
  mutations: {
    SET_max_seq_nr: (state, value) => (state.max_seq_nr = value),
    SET_measureSet_max_seq_nr: (state, value) => (state.measureSet_max_seq_nr = value),
    SET_search_company: (state, payload) => (state.searches[payload.companyId] = payload.search),
    SET_active_company: (state, payload) => (state.activeCompany = payload.company),
    SET_cognito_user: (state, payload) => (state.cognito_user = payload),
    SET_user_info: (state, payload) => (state.user_info = payload),
    SET_logged_in: (state, value) => (state.logged_in = value),
    SET_sidebarVisible: (state, value) => Vue.set(state, "sidebarVisible", value),
    SET_selectedCompany: (state, value) => Vue.set(state, "selectedCompany", value),
  },
};

const copyProcesses = {
  state: {
    companies: [],
    companyProcesses: [],
    currentCompany: null,
    currentProcess: null,
  },
  mutations: {
    SET_COMPANIES: (state, payload) => (state.companies = payload.companies),
    SET_COMPANY_PROCESSES: (state, payload) => (state.companyProcesses = payload.companyProcesses),
    SET_SELECTED_COMPANY: (state, payload) =>
      (state.currentCompany = state.companies.filter((item) => item.id === payload.currentCompanyId)[0]),
    SET_CURRENT_PROCESS: (state, payload) => (state.currentProcess = payload.currentProcess),
  },
  actions: {
    async getCompanies({ state, commit, rootState }) {
      try {
        let vueInstance = this._vm;
        let resp = await vueInstance.$Amplify.API.graphql(vueInstance.$Amplify.graphqlOperation(listCompanys));
        var companies = resp.data.listCompanys.items;
        companies.sort((a, b) => (a.name > b.name ? 1 : -1));
        commit("SET_COMPANIES", { companies: companies });
      } catch (e) {
        console.error("Error fetching companies in vuex", e);
      }
    },
    async getProcessesForCompanies({ state, commit, rootState }) {
      try {
        let vueInstance = this._vm;
        let resp = await vueInstance.$Amplify.API.graphql(
          vueInstance.$Amplify.graphqlOperation(getCompany, { id: state.currentCompany.id })
        );
        commit("SET_COMPANY_PROCESSES", { companyProcesses: resp.data.getCompany.processes.items });
      } catch (e) {
        console.error("Error fetching company processes in vuex", e);
      }
    },
  },
};

const userdata = {
  state: { value: null },
  mutations: {
    SET_userdata: (state, value) => (state.value = value),
  },
  actions: {
    async setUserdata({ state, commit, rootState }, newvalue) {
      let oldvalue = state.value;
      commit("SET_userdata", newvalue);
      let vue = this._vm;
      try {
        vue.$eventHub.emit("sync-status-syncing");
        let resp = await vue.$Amplify.API.graphql(vue.$Amplify.graphqlOperation(updateUserdata, { input: newvalue }));
        vue.$eventHub.emit("sync-status-success", {
          entity_type: "Profildaten",
          entity_label: "",
          sync_type: "update",
        });
      } catch (e) {
        vue.$eventHub.emit("sync-status-failure", {
          entity_type: "Profildaten",
          entity_label: "",
          sync_type: "update",
          error: e.errors[0].message,
        });
        commit("SET_userdata", oldvalue);
      }
    },
    async loadUserdata({ state, commit, rootState }) {
      try {
        let vueInstance = this._vm;
        let resp = await vueInstance.$Amplify.API.graphql(vueInstance.$Amplify.graphqlOperation(listUserdatas));
        if (resp.data.listUserdatas.items.length > 0) {
          commit("SET_userdata", resp.data.listUserdatas.items[0]);
        } else {
          try {
            let resp2 = await vueInstance.$Amplify.API.graphql(
              vueInstance.$Amplify.graphqlOperation(createUserdata, { input: {} })
            );
            commit("SET_userdata", resp2.data.createUserdata);
          } catch (e) {
            console.error("Error creating userdata in vuex", e);
          }
        }
      } catch (e) {
        console.error("Error fetching userdata in vuex", e);
      }
    },
  },
};

const store = new Vuex.Store({
  modules: {
    originalStore: originalStore,
    copyProcesses: copyProcesses,
    userdata: userdata,
  },
});

export default store;

const listCompanys = `query ListCompanys {
  listCompanys(limit:200) {
    items {
      id
      name
    }
  }
}
`;

const getCompany = `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    processes(limit: 500) {
      items {
        id
        text_header
        seq_nr
        status
        text_legal
        legal_basis
        text_problem
        damage_scenario
        risk_probability
        data_category
        victim_risk
        damage_rate
        dept_resp
        recipient_category
        delete_period
        createdAt
        updatedAt
        archived_at
        deleted_at
        measureSets(limit: 100) {
          items {
            process {
              id
            }
            measureSet {
              id
            }
            status
          }
        }
        measures(limit: 100) {
          items {
            id
            label
            description
            status
          }
        }
      }
      nextToken
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;
